import { IBrandigApiProps } from '../services/dynamic-branding-service';

export const GETNET_BRAND: Partial<IBrandigApiProps> = {
  name: 'getnet',
  primary_color: '#EC0000',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#0c2340',
  //secondary
  secondary_color: '#0032EC',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#3A8340',
  third_color_contrast: '#ffffff',

  logo: 'https://inteliposresources.s3.amazonaws.com/intelipos/images/logos/logo_w.png',
  privacy_url: 'https://vbandrew.000webhostapp.com/getnet/privacy',
  support_email: 'soporteapp@getnet.com',
  terms_url: 'https://vbandrew.000webhostapp.com/getnet/tos',
  tradename: 'Getnet',
};
export const TELMEX_BRAND: Partial<IBrandigApiProps> = {
  name: 'telmex',
  primary_color: '#0069D9',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#000000',
  //secondary
  secondary_color: '#3366ff',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#35415b',
  third_color_contrast: '#ffffff',

  logo: 'https://cloudfront-us-east-1.images.arcpublishing.com/sdpnoticias/2AGSRHIP7RLZJL3RTB5XXIZ3FM.png',
  privacy_url: 'https://telmex.com/web/acerca-de-telmex/aviso-de-privacidad',
  support_email: 'soporteapp@telmex.minegocio.digital',
  terms_url: 'https://vbandrew.000webhostapp.com/telmex/tos',
  tradename: 'Telmex',
};
export const TELCEL_BRAND: Partial<IBrandigApiProps> = {
  name: 'telcel',
  primary_color: '#00338D',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#0c2340',
  //secondary
  secondary_color: '#00B0CA',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#FF7900',
  third_color_contrast: '#ffffff',

  logo: 'https://www.cruzazulfc.com.mx/wp-content/uploads/2017/02/telcel-bco.png',
  privacy_url: 'https://vbandrew.000webhostapp.com/telcel/privacy',
  support_email: 'soporteapp@telcel.com',
  terms_url: 'https://vbandrew.000webhostapp.com/telcel/tos',
  tradename: 'Telcel',
};
export const TELNOR_BRAND: Partial<IBrandigApiProps> = {
  name: 'telnor',
  primary_color: '#444444',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#0c2340',
  //secondary
  secondary_color: '#025E4B',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#D88700',
  third_color_contrast: '#ffffff',

  logo: 'https://www.tudecide.com/assets/images/empresas/telnor.png',
  privacy_url: 'https://vbandrew.000webhostapp.com/telnor/privacy',
  support_email: 'soporteapp@telnor.com',
  terms_url: 'https://vbandrew.000webhostapp.com/telnor/tos',
  tradename: 'Telnor',
};
export const TOTALPLAY_BRAND: Partial<IBrandigApiProps> = {
  name: 'totalplay',
  primary_color: '#3B4559',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#0c2340',
  //secondary
  secondary_color: '#00B5E2',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#F04E98',
  third_color_contrast: '#ffffff',

  logo: 'https://tutech.tech/wp-content/uploads/2021/02/total_play_logo-1024x248.png',
  privacy_url: 'https://vbandrew.000webhostapp.com/tpn/privacy',
  support_email: 'soporteapp@tpn.com',
  terms_url: 'https://vbandrew.000webhostapp.com/tpn/tos',
  tradename: 'Totalplay',
};
export const MND_BRAND: Partial<IBrandigApiProps> = {
  name: 'mnd',
  primary_color: '#464548',
  primary_color_contrast: '#ffffff',
  primary_text_color: '#0c2340',
  //secondary
  secondary_color: '#558889',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#EC008C',
  third_color_contrast: '#ffffff',

  logo: 'https://espacio-stg.virket.com/assets/img/espacio/main-logo.svg',
  privacy_url: 'https://sitios.michoacan.digital/aviso-de-privacidad/-/-/',
  support_email: 'soporteapp@mnd.com',
  terms_url: 'https://vbandrew.000webhostapp.com/mnd/tos',
  tradename: 'Mi Negocio Digital',
};
export const LIGHT_BRAND: Partial<IBrandigApiProps> = {
  name: 'light',
  primary_color: '#c7e0fe',
  primary_color_contrast: '#1a1b1d',
  primary_text_color: '#1a1b1d',
  //secondary
  secondary_color: '#558889',
  secondary_color_contrast: '#ffffff',
  secondary_text_color: '#1e81b0',
  //tertiary
  third_color: '#EC008C',
  third_color_contrast: '#ffffff',

  logo: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/bb/Random.org_logo.svg/1280px-Random.org_logo.svg.png',
  privacy_url: 'https://es.wikipedia.org/wiki/Wikipedia:Portada',
  support_email: 'soporteapp@light.com',
  terms_url: 'https://vbandrew.000webhostapp.com/mnd/light',
  tradename: 'A Light Brand',
};
